module.exports = __webpack_public_path__ + "img/receive-gifts.7d803a8d.png";